import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import Handlebars from 'handlebars';

Snappy.Component.ContactForm = class ContactForm extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-contact-form';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.addEventListeners();
        localStorage.removeItem(this.$unsavedDataStorageNamespace);
    }

    setVars() {
        this.$form = this.$element.find('.fa-contact-form__form');
        this.$messageContainer = this.$element.find('.message-container');
        this.errorClass = 'fa-input-field--error';
        this.messageClass = 'fa-input-field__error-message';
        this.$addFieldButton = this.$element.find('.js-add-field-button');
        this.$formItself = this.$element.find('[data-form-itself]');
        this.$thankYouMessage = this.$element.find('[data-thank-you-message]');
        this.$fileinputs = this.$element.find('.js-inputfile');
        this.$conditionalSelect = this.$element.find('[data-conditional-select]');
        this.$conditionalOptions = this.$element.find('[data-conditional-option]');
        this.$removeSectionButton = this.$element.find('[data-remove-section-button]');
        this.$addSectionButton = this.$element.find('[data-add-section-button]');
        this.$newSectionsPlaceholder = this.$element.find('[data-new-sections-placeholder]');
        this.$submitButton = this.$element.find(':submit');
        this.isProfile = this.$element[0].hasAttribute('data-profile-form');
        this.isHandleUnsavedData = this.$element.is('[data-unsaved-storage-namespace]');
        this.$unsavedDataStorageNamespace = this.$element.attr('data-unsaved-storage-namespace');
        this.$initialState = this.$form.serialize();
        this.$preloader = this.$element.find('.js-cfa-preloader');
        this.$avatar = this.$element.find('.js-avatar');

        if (window.FileReader) {
            this.fileReader = new FileReader();
        }
    }

    addEventListeners() {
        this.$form.on('submit', this.onFormSubmission.bind(this));
        this.$addFieldButton.on('click', this.addField.bind(this));
        if (this.$fileinputs.length) {
            this.$fileinputs.on('change', this.onInputFileChange.bind(this));
        }
        if (this.$conditionalSelect.length) {
            this.$element.on(
                'change',
                this.$conditionalSelect,
                this.onConditionalSelectChange.bind(this)
            );
        }
        if (this.$addSectionButton.length) {
            this.$addSectionButton.on('click', this.onAddSectionButtonClick.bind(this));
        }
        if (this.$removeSectionButton.length) {
            this.$element.on(
                'click',
                this.$removeSectionButton,
                this.onRemoveSectionButtonClick.bind(this)
            );
        }


        this.$form.on('change', this.onFormChange.bind(this));

        if (this.isProfile) {
            this.fileReader.addEventListener('loadend', this.onFileReaderLoadFile.bind(this));
        }
    }

    onAddSectionButtonClick(e) {
        e.preventDefault();

        let $target = $(e.target);

        let $lastSectionIndex = this.getLastSectionIndex();

        let $templateType = $target.attr('data-add-section-template-type');

        let $templateSource = $(`#${$templateType}-section-template`).html();

        let $newSectionHtml = this.getNewSectionHtml($templateSource, $lastSectionIndex + 1);

        this.$newSectionsPlaceholder.append($newSectionHtml);

        this.$conditionalOptions = this.$element.find('[data-conditional-option]');
    }

    onFormChange(e) {
        if (this.isHandleUnsavedData) {
            this.handleUnsavedData();
        }

        this.removeValidationError({element: e.target.name});

    }

    isDirty() {
        return this.$form.serialize() !== this.$initialState;
    }

    getLastSectionIndex() {
        let $availableSections = this.$element.find('[data-section]');

        let sectionsIndexes = [];
        let maxIndex = null;

        $availableSections.each((index, el) => {
            sectionsIndexes.push(parseInt($(el).attr('data-section-index')));
        });

        maxIndex = sectionsIndexes.reduce((a, b) => Math.max(a, b), 0);

        return maxIndex;
    }

    getNewSectionHtml(template, index) {
        let sectionTemplateFn = Handlebars.compile(template);
        return sectionTemplateFn({ sectionIndex: index });
    }

    onRemoveSectionButtonClick(e) {
        let $target = $(e.target);

        if (!$target[0].hasAttribute('data-remove-section-button')) return;

        let $sectionIndexToRemove = $target.attr('data-remove-section-button-index');

        this.$element.find(`[data-section-index="${$sectionIndexToRemove}"]`).remove();
    }

    onConditionalSelectChange(e) {
        let $target = $(e.target);

        if (!$target[0].hasAttribute('data-conditional-select')) return;

        let $choosenOption = this.getInputValue($target);
        let $conditionalSelectGroup = $target.attr('data-conditional-group');

        $target
            .closest('.cfa-field')
            .removeClass('fa-input-field--error')
            .find('.cfa-field__error')
            .text('');

        $target.removeClass('fa-input-field--error');

        this.$conditionalOptions
            .filter(`[data-conditional-group="${$conditionalSelectGroup}"]`)
            .hide()
            .find('[data-conditional-input]')
            .val('');
        this.$element
            .find(`[data-${$choosenOption}]`)
            .filter(`[data-conditional-group="${$conditionalSelectGroup}"]`)
            .show();
    }

    getInputValue($input) {
        let type = $input.attr('type');

        if( type=== 'radio') {
            return $(`input[name=${$input.attr("name")}]:checked`).val();
        }

        if (type === 'checkbox') return $input.is(':checked');

        return $input.val();
    }

    toggleLoading() {
        if (this.$preloader.length) {
            this.$preloader.toggleClass('cfa-preloader--active', this.isLoading);
        }
    }

    onFormSubmission(event) {
        event.preventDefault();
        this.toggleLoading();
        if (this.$preloader.length) {
            this.$preloader.attr('aria-busy', true);
        }

        $.ajax({
            url: (this.formAction = this.$form.attr('action')),
            method: (this.formMethod = this.$form.attr('method')),
            data: new FormData(event.target),
            contentType: false,
            cache: false,
            processData: false
        }).fail(this.handleFailedResponse.bind(this)).always(this.handleValidationResponse.bind(this));
    }

    handleFailedResponse(response){
        const pathname = window.location.pathname;

        if (response.status === 403) {
            window.location = `${response.responseJSON.logOnUrl}?ReturnUrl=${pathname}`;
        }
    }

    handleValidationResponse(response) {
        this.toggleLoading();
        if (this.$preloader.length) {
            this.$preloader.attr('aria-busy', false);
        }

        if (!response.success) {
            $.each(response.fields, (i, field) => {
                if (!field.success) {
                    this.showValidationError(field);
                } else {
                    this.removeValidationError(field);
                }
            });
            this.scrollToError(this.$form.find('.fa-input-field--error:first'));
        } else {
            this.handleSuccess(response);
        }
    }

    getEscapedSelector(field) {

        return field.element ? field.element.replace(/(:|\.|\[|\])/g, '\\$1') : null;
    }

    showValidationError(field) {

        let escapedSelector = this.getEscapedSelector(field);

        const $element = this.$form.find(`[name=${escapedSelector}]`);

        $element
            .addClass(this.errorClass)
            [$element.is(':checkbox') ? 'parents' : 'closest']('.cfa-field')
            .addClass(this.errorClass)
            .find(`.${this.messageClass}`)
            .text(field.message);
    }

    onInputFileChange(e) {
        let label = e.target.nextElementSibling;
        let labelVal = label.innerHTML;
        let fileName = '';

        fileName = e.target.value.split('\\').pop();

        const filelabel = label.querySelector('.js-inputfile-label');

        if (this.isProfile) {
            filelabel.innerHTML = 'Change Photo';
            const file = e.target.files[0];
            this.showAvatar(file);

        } else {
            if (fileName && filelabel) {
                filelabel.innerHTML = fileName;
            } else {
                label.innerHTML = labelVal;
            }
        }
    }

    showAvatar(file) {
        if (window.File && window.FileReader && window.FileList && window.Blob) {
            if (file) {
                this.fileReader.readAsDataURL(file);
            }
        }
    }
    onFileReaderLoadFile() {
        this.updateAvatar(this.fileReader.result);

    }

    removeValidationError(field) {
        let escapedSelector = this.getEscapedSelector(field);

        const $element = this.$form.find(`[name=${escapedSelector}]`);

        $element
            .removeClass(this.errorClass)
            [$element.is(':checkbox') ? 'parents' : 'closest']('.cfa-field')
            .removeClass(this.errorClass)
            .find(`.${this.messageClass}`)
            .text('');
    }

    getNextIndex() {}

    addNewSection(template) {}

    handleUnsavedData() {
        this.$form[this.isDirty() ? 'addClass' : 'removeClass']('is-dirty');

        let formName = this.$form.closest('.js-tab').attr('data-target');

        let unsavedData = {};

        unsavedData[formName] = this.isDirty();

        $(window).trigger('unsaved:changed', [this.$unsavedDataStorageNamespace, unsavedData]);

        if (this.isDirty()) {
            this.$submitButton.text('Save');
        }
    }

    handleSuccess(response) {
        const activeClass = 'active';

        if (this.isHandleUnsavedData) {
            this.$initialState = this.$form.serialize();
            this.handleUnsavedData();
        }

        this.removeErrors();

        if (!this.isProfile) {
            this.resetForm();
        }

        this.$messageContainer.addClass(activeClass);

        if (this.$thankYouMessage.length && this.$formItself.length) {
            this.$form.css('height', this.$form.outerHeight());
            this.$formItself.fadeOut(() => {
                this.$thankYouMessage.fadeIn(() => {
                    this.$form.wrapInner('<div/>');
                    let newHeight = this.$form.find('div:first').height();
                    this.$form.css('height', newHeight);
                });
            });
        }

        // commented code below didn't work so now it's commented and is to be removed
        // $.each(response.fields, (i, field) => {
        //     this.removeValidationError(field);
        // });

        window.setTimeout(
            function() {
                this.$messageContainer.removeClass(activeClass);
            }.bind(this),
            10000
        );

        if (this.isProfile) {
            this.$submitButton.text('Saved');
            this.updateAvatar(response.photo);
        }

        if (this.$body.hasClass('cfa-generic')) {
            $(window).trigger('gtm:send', ['Contact Us', 'Submit', 'Submit an enquiry']);
        }

        this.trackSubmission();
    }

    updateAvatar(photoUrl) {
        this.$avatar.attr('src', photoUrl);
    }

    trackSubmission() {
        const category = this.$element.attr('data-gtm-category');
        const action = this.$element.attr('data-gtm-action');
        const label = this.$element.attr('data-gtm-label') || '';

        if (category && action) {
            $(window).trigger('gtm:send', [category, action, label]);
        }
    }

    removeErrors() {
        this.$form.find('input, select, textarea').each((i, element) => {
            $(element)
                .removeClass(this.errorClass)
                [$(element).is(':checkbox') ? 'parents' : 'closest']('.cfa-field')
                .removeClass(this.errorClass)
                .find(`.${this.messageClass}`)
                .text('');
        });
    }

    addField(e) {
        e.preventDefault();

        let $clonedField = $(e.target)
            .closest('[data-clonable]')
            .find('[data-to-clone]')
            .not('[data-cloned]')
            .clone()
            .val('')
            .attr('data-cloned', '');

        $(e.target)
            .closest('[data-clonable]')
            .find('.js-added-fields-container')
            .append($clonedField);
    }

    resetForm() {
        this.$form.find('input, select, textarea').each((i, element) => {
            element.value = '';
        });
    }

    scrollToError(el) {
        if(el.length) {
            $('html, body').animate({ scrollTop: el.offset().top - 100 }, 300);
        }
    }

};



// WEBPACK FOOTER //
// ./components/contactForm/scripts/contactForm.js